"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var elements_1 = require("./elements");
var Column = function (_a) {
    var col = _a.col, colIndex = _a.colIndex, _b = _a.header, header = _b === void 0 ? [] : _b;
    if (header.includes('l') && colIndex === 0) {
        return react_1["default"].createElement(elements_1.LeftTh, { dangerouslySetInnerHTML: { __html: col } });
    }
    return react_1["default"].createElement(elements_1.Td, { dangerouslySetInnerHTML: { __html: col } });
};
exports["default"] = react_1["default"].memo(Column);
